export const Carbos = {
    ARROZBLANCO: {
        name: "Arroz blanco",
        netMacro: 35,
        totalWeight: 50
    },
    TORTITASARROZMAIZ: {
        name: "Tortitas de arroz/maíz",
        netMacro: 35,
        totalWeight: 50
    },
    PANSESAMO: {
        name: "Pan sésamo (wasa)",
        netMacro: 35,
        totalWeight: 50
    },
    PASTA: {
        name: "Pasta",
        netMacro: 35,
        totalWeight: 50
    },
    PAN: {
        name: "Pan",
        netMacro: 35,
        totalWeight: 70
    },
    AVENA: {
        name: "Avena",
        netMacro: 35,
        totalWeight: 50
    },
    QUINOA: {
        name: "Quinoa",
        netMacro: 35,
        totalWeight: 50
    },
    CUSCUS: {
        name: "Cuscús",
        netMacro: 35,
        totalWeight: 50
    },
    ÑOQUIS: {
        name: "Ñoquis",
        netMacro: 35,
        totalWeight: 100
    },
    PATATA: {
        name: "Patata",
        netMacro: 35,
        totalWeight: 200
    },
    BATATA: {
        name: "Batata",
        netMacro: 35,
        totalWeight: 200
    },
    MAIZ: {
        name: "Maíz",
        netMacro: 35,
        totalWeight: 200
    },
    LENTEJAS: {
        name: "Lentejas",
        netMacro: 35,
        totalWeight: 60
    },
    GARBANZOS: {
        name: "Garbanzos",
        netMacro: 35,
        totalWeight: 60
    },
    WRAAP: {
        name: "Wraap",
        netMacro: 35,
        totalWeight: 70
    },
    MANZANA: {
        name: "Manzana",
        netMacro: 35,
        totalWeight: 250
    },
    PLATANO: {
        name: "Plátano",
        netMacro: 35,
        totalWeight: 150
    },
    PIÑA: {
        name: "Piña",
        netMacro: 35,
        totalWeight: 200
    },
    MANGO: {
        name: "Mango",
        netMacro: 35,
        totalWeight: 200
    },
    KIWI: {
        name: "Kiwi",
        netMacro: 35,
        totalWeight: 300
    },
    PERA: {
        name: "Pera",
        netMacro: 35,
        totalWeight: 200
    },
    MANDARINA: {
        name: "Mandarina",
        netMacro: 35,
        totalWeight: 300
    },
    ALBARICOQUE: {
        name: "Albaricoque",
        netMacro: 35,
        totalWeight: 400
    },
    CIRUELA: {
        name: "Ciruela",
        netMacro: 35,
        totalWeight: 300
    },
    CAQUI: {
        name: "Caqui",
        netMacro: 35,
        totalWeight: 150
    },
    ARANDANOS: {
        name: "Arándanos",
        netMacro: 35,
        totalWeight: 300
    },
    FRESAS: {
        name: "Fresas",
        netMacro: 35,
        totalWeight: 400
    },
    CEREZAS: {
        name: "Cerezas",
        netMacro: 35,
        totalWeight: 250
    },
    FRAMBUESA: {
        name: "Frambuesa",
        netMacro: 35,
        totalWeight: 800
    },
    MELON: {
        name: "Melón",
        netMacro: 35,
        totalWeight: 450
    },
    SANDIA: {
        name: "Sandía",
        netMacro: 35,
        totalWeight: 700
    },
    MELOCOTON: {
        name: "Melocotón",
        netMacro: 35,
        totalWeight: 250
    }
};
